import React from 'react';
import ModalImage from "react-modal-image";

function ReceiptFormImages({ formState, setFormState, receiptImgUrl }) {

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormState({
            ...formState,
            [name]: files[0],
        });
    };

    const renderPreview = (filePath, altText, labelText) => {
        if (!filePath) return null;

        const fullUrl = `${process.env.REACT_APP_IMG_URI}/${filePath}`;
        const isPDF = filePath.toLowerCase().endsWith('.pdf');

        return (
            <div style={{ width: 100 }}>
                {isPDF ? (
                    <a
                        href={fullUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline text-sm"
                    >
                        {labelText || "View PDF"}
                    </a>
                ) : (
                    <ModalImage
                        small={fullUrl}
                        large={fullUrl}
                        alt={altText}
                    />
                )}
            </div>
        );
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-6">
            <div className="flex flex-col">
                <label className="mb-2 font-semibold text-gray-700">
                    Challan Image <span className="text-red-500">*</span>
                </label>
                <input
                    type="file"
                    name="receipt_challan_img"
                    onChange={handleFileChange}
                    className="input-style"
                />
                {renderPreview(receiptImgUrl.receipt_challan_img, "Challan Image", "Challan_Image.pdf")}
            </div>

            <div className="flex flex-col">
                <label className="mb-2 font-semibold text-gray-700">Weight Slip Image</label>
                <input
                    type="file"
                    name="receipt_weight_slip_img"
                    onChange={handleFileChange}
                    className="input-style"
                />
                {renderPreview(receiptImgUrl.receipt_weight_slip_img, "Weight Slip", "Weight_Slip.pdf")}
            </div>

            <div className="flex flex-col">
                <label className="mb-2 font-semibold text-gray-700">Item Image</label>
                <input
                    type="file"
                    name="receipt_item_img"
                    onChange={handleFileChange}
                    className="input-style"
                />
                {renderPreview(receiptImgUrl.receipt_item_img, "Item Image", "Item_Image.pdf")}
            </div>

            <div className="flex flex-col">
                <label className="mb-2 font-semibold text-gray-700">
                    Invoice Image <span className="text-red-500">*</span>
                </label>
                <input
                    type="file"
                    name="receipt_invoice_img"
                    onChange={handleFileChange}
                    className="input-style"
                />
                {renderPreview(receiptImgUrl.receipt_invoice_img, "Invoice", "Invoice_Image.pdf")}
            </div>

            <div className="flex flex-col">
                <label className="mb-2 font-semibold text-gray-700">Quality Checked Image</label>
                <input
                    type="file"
                    name="receipt_quality_img"
                    onChange={handleFileChange}
                    className="input-style"
                />
                {renderPreview(receiptImgUrl.receipt_quality_img, "Quality", "Quality_Checked.pdf")}
            </div>

            <div className="flex flex-col">
                <label className="mb-2 font-semibold text-gray-700">Weight Kg</label>
                <input
                    type="text"
                    name="receipt_weight_kg"
                    value={formState.receipt_weight_kg}
                    onChange={(e) =>
                        setFormState((prev) => ({ ...prev, receipt_weight_kg: e.target.value }))
                    }
                    className="input-style"
                    placeholder="Weight Kg"
                />
            </div>
        </div>
    );
}

export default ReceiptFormImages;